var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const options = [
    { id: 1, name: "Current" },
    { id: 2, name: "Continuing" },
    { id: 3, name: "Inactive" },
];
export default class StudentStatusService {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2322 - Type '{ id: number; name: string; }[]' is not assignable to type 'StudentStatus[]'.
            return options.filter((opt) => opt.name.toLowerCase().includes(search.toLowerCase()));
        });
    }
    static findAllById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2322 - Type '{ id: number; name: string; }[]' is not assignable to type 'StudentStatus[]'.
            return options.filter((opt) => ids.includes(opt.id));
        });
    }
}
